var exports = {
  "kL": "x234b8571--16b7e8--container",
  "Qs": "x234b8571--16b7e8--content",
  "ed": "x234b8571--16b7e8--disclaimer",
  "Pf": "x234b8571--16b7e8--label",
};

module.exports = exports;
